import Header from "./sub-components/Header";
import BaseNav from "./sub-components/BaseNav";
import "../../styles/marketplace.css";
import Ad from "./sub-components/Ad";
import {useState,useEffect} from 'react';
import { db } from "./firebase/firebase";
import { doc, setDoc,onSnapshot, getDocs, collection,getDoc ,query, addDoc, where, updateDoc } from "firebase/firestore";
import {encrypt} from "../../encryption/"
const Marketplace = () => {
    const [data,setData] = useState(null)
    useEffect(()=>{
        const q = query(collection(db, "ads"))
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const data_array = [];
          querySnapshot.forEach((doc) => {
              data_array.push({...doc.data(),id:doc.id});
          });
         setData(data_array.sort((a,b)=>b.time - a.time))
        });
        return ()=>{
            unsubscribe();
        }
    },[data])
    const [active,setActive] = useState("All");
    const tabs = ["All","Products","Forex", "WebDesign","GraphicDesign","Cryptocurrency"]
    const filtered_data = active == "All" ? data : data.filter(each=> each.category == active).sort((a,b)=>b.time - a.time);
    return (
        <div className="dashboard marketplace-container utility">
            <Header />
            <BaseNav active={"Marketplace"} />
            <div className="container">
                <div className="categories">
                    <div className="scroll-wrapper">
                        <div className="container">
                          {tabs.map(each=>(<span onClick={()=>{setActive(each)}} className={`${each == active ? "active-tab" : ""}`}>{each}</span>))}
                        </div>
                        
                    </div>
                </div>
               { data && <div className="ads">
                   {
                       filtered_data.map(each=>(<Ad creator={each.creator} image={each.image} stats={each.engagements.length} key={each.id} id={each.id} chunk={encrypt(JSON.stringify(each))} />))
                   }
                </div>
                   
               } 
            </div>
        </div>
    );
}

export default Marketplace;